import { msg } from '@lingui/core/macro';
import { MediaGenerationJob, MediaGenerationJobStatus } from 'modules/manager/domain/graphql/media-generation-jobs';
import type { MessageDescriptor } from 'shared/i18n';

export const MEDIA_GENERATION_JOB_STATUS_LABELS: Record<MediaGenerationJobStatus, MessageDescriptor> = {
  PENDING: msg`В очереди`,
  RENDERING: msg`Рендер`,
  READY: msg`Черновик`,
  FAILED: msg`Ошибка`,
  SKIPPED: msg`Пропущено`,
  DISCARDED: msg`Отклонено`,
  CANCELLED: msg`Отменено`,
  PUBLISHED: msg`Опубликовано`,
};

/** Задача ещё в работе: список с такой задачей надо перечитывать, пока картинка не появится. */
export const ACTIVE_MEDIA_GENERATION_JOB_STATUSES: MediaGenerationJobStatus[] = ['PENDING', 'RENDERING'];

export function isActiveMediaGenerationJob(job: MediaGenerationJob): boolean {
  return ACTIVE_MEDIA_GENERATION_JOB_STATUSES.includes(job.status);
}

/** Публикуется только готовый черновик с картинкой: пост в Telegram собирается из неё. */
export function canPublishMediaGenerationJob(job: MediaGenerationJob): boolean {
  return job.status === 'READY' && Boolean(job.image?.externalUrl);
}

/**
 * Что показывают «Картинки» соревнования: всё, кроме убранного — отклонённого (`DISCARDED`),
 * отменённого и пропущенного. Значения — в нижнем регистре, как их принимает фильтр
 * `MediaGenerationJobsInput.statuses` (так же фильтрует и «Очередь медиа»).
 */
export const VISIBLE_MEDIA_GENERATION_JOB_STATUSES = ['pending', 'rendering', 'ready', 'failed', 'published'];

/**
 * Чем задачу убирают из «Картинок»: готовый черновик — отклоняем (`discard`, след остаётся в
 * очереди супер-админа), ошибку — удаляем (картинки у неё нет, хранить нечего). Рендер и
 * ожидание не трогаем: их отменяет супер-админ в очереди.
 */
export function mediaGenerationJobHideAction(job: MediaGenerationJob): 'discard' | 'delete' | null {
  if (job.status === 'READY') return 'discard';
  if (job.status === 'FAILED') return 'delete';
  return null;
}
